import { render, staticRenderFns } from "./PeriodicityMonthsMultipleSelector.vue?vue&type=template&id=fda9f628&scoped=true"
import script from "./PeriodicityMonthsMultipleSelector.vue?vue&type=script&lang=js"
export * from "./PeriodicityMonthsMultipleSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fda9f628",
  null
  
)

export default component.exports